import { useMemo } from "react";

const useGanttColumns = () => {
	// Get custom captions from user session
	const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me")) || {};

	const columns = useMemo(() => [
		{
			id: "text",
			header: customCaptions?.serviceWorkOrder || "Work Order",
			width: 250,
		},
		{
			id: "interval",
			header: customCaptions?.interval || "Interval",
			flexGrow: 1,
		},
		{
			id: "status",
			header: "Status",
			width: 100
		},
		{
			id: "percComplete",
			header: "% Complete",
			width: 80
		},
		{
			id: "start",
			header: "Start Date",
			width: 80,
		},
		{
			id: "estimatedMinutes",
			header: "Est Hours",
			width: 70
		},
	], [customCaptions]);

	return columns;
};

export default useGanttColumns;
